/* Kaddanse — ajout panier multi-lignes (R8 bundle, R9 cross-sell tiroir).
   Module ES : passe par l'importmap du thème et émet le CartLinesUpdateEvent
   OFFICIEL — le tiroir se re-rend, la pastille se met à jour et le tiroir
   s'auto-ouvre exactement comme après un ajout natif. Sans `detail.sections`,
   cart-items-component retombe sur sectionRenderer.renderSection (vérifié).
   Délégation document : survit au morph du tiroir (piège Horizon documenté). */
import { CartLinesUpdateEvent } from '@shopify/events';

const routes = (window.Theme && window.Theme.routes) || {};
const ADD_URL = routes.cart_add_url || '/cart/add';
const CART_URL = routes.cart_url || '/cart';

async function kddAdd(items, sourceEl) {
  const deferred = CartLinesUpdateEvent.createPromise();
  const target = sourceEl && sourceEl.isConnected ? sourceEl : document.body;

  target.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity || 1 })),
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(`${ADD_URL}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || 'Ajout impossible');

    const ajaxCart = await fetch(`${CART_URL}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
      detail: {
        items: ajaxCart.items,
        source: 'kdd-panier',
        itemCount: items.reduce((n, i) => n + (i.quantity || 1), 0),
        didError: false,
      },
    });
    return true;
  } catch (err) {
    deferred.reject(err);
    throw err;
  }
}

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-kdd-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();

  let items = [];
  try {
    items = JSON.parse(btn.getAttribute('data-kdd-items') || '[]');
  } catch (_) {
    /* attribut malformé : on ne fait rien */
  }
  if (!items.length) return;

  const label = btn.querySelector('[data-kdd-add-label]') || btn;
  const avant = label.textContent;
  btn.disabled = true;
  btn.classList.add('kdd-add--pending');

  try {
    await kddAdd(items, btn);
    label.textContent = btn.getAttribute('data-kdd-added-label') || 'Ajouté';
    setTimeout(() => {
      /* le nœud peut avoir été remplacé par le morph : sans conséquence */
      label.textContent = avant;
      btn.disabled = false;
      btn.classList.remove('kdd-add--pending');
    }, 2500);
  } catch (err) {
    label.textContent = 'Réessayer';
    btn.disabled = false;
    btn.classList.remove('kdd-add--pending');
    console.warn('[kdd-panier]', err);
  }
});

/* ══════════════════════════════════════════════════════════════════
   « Ajouter à la commande » (deck fiche produit v2, 18.08)

   Les cases cochées dans la buy-box partent au panier AVEC le produit, en
   UNE seule requête — le client ne clique qu'une fois et le tiroir s'ouvre
   une fois.

   Interception en phase de CAPTURE, et UNIQUEMENT si au moins une case est
   cochée : sans case cochée, le parcours natif du thème n'est pas touché du
   tout (validation, variantes indisponibles, messages d'erreur). Si le
   formulaire ou la variante sont introuvables, on laisse aussi le natif
   faire son travail plutôt que de risquer un panier faux.
   ══════════════════════════════════════════════════════════════════ */
document.addEventListener(
  'click',
  async (e) => {
    const btn = e.target.closest && e.target.closest('.add-to-cart-button');
    if (!btn || btn.disabled) return;

    const cases = Array.from(document.querySelectorAll('[data-kdd-addon]:checked'));
    if (!cases.length) return; // rien de coché → parcours natif intact

    const form = btn.closest('form') || document.querySelector('product-form-component form');
    const champ = form && form.querySelector('input[name="id"], select[name="id"]');
    if (!champ || !champ.value) return; // on préfère le natif à un panier faux

    const qteChamp = form.querySelector('input[name="quantity"]');
    const qte = Math.max(1, parseInt(qteChamp && qteChamp.value, 10) || 1);

    e.preventDefault();
    e.stopPropagation();

    const items = [{ id: Number(champ.value), quantity: qte }].concat(
      cases.map((c) => ({ id: Number(c.getAttribute('data-kdd-addon')), quantity: 1 }))
    );

    btn.disabled = true;
    btn.classList.add('kdd-add--pending');
    try {
      await kddAdd(items, btn);
      cases.forEach((c) => {
        c.checked = false;
        c.dispatchEvent(new Event('change', { bubbles: true }));
      });
    } catch (err) {
      console.warn('[kdd-panier] ajout avec accessoires', err);
    } finally {
      btn.disabled = false;
      btn.classList.remove('kdd-add--pending');
    }
  },
  true
);

/* 16.10 : sur ordinateur, le volet panier est une carte flottante non modale
   posée sur un voile (bf-habillage.css). Un clic hors de la carte la referme,
   comme le ferait un clic sur le fond d'un dialog modal. */
document.addEventListener(
  'click',
  (e) => {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    const dlg = Array.from(document.querySelectorAll('dialog.theme-drawer__dialog[open]')).find((d) =>
      d.querySelector('.cart-drawer__inner')
    );
    if (!dlg || dlg.contains(e.target)) return;
    if (e.target.closest && e.target.closest('[ref="cartDrawerButton"], .header-actions__cart-icon, cart-icon, a[href$="/cart"], button[aria-label="Panier"]')) return;
    const fermer = dlg.querySelector('.theme-drawer__close-button');
    if (fermer) {
      e.preventDefault();
      e.stopPropagation();
      fermer.click();
    }
  },
  true
);
